// extracted by mini-css-extract-plugin
module.exports = {"container":"GenericPage_container__S9skI","spacing":"GenericPage_spacing__Qydoz"};